import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

interface AdminRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  
  useEffect(() => {
    // Kiểm tra authentication status
    setIsAuthenticated(authService.isAuthenticated());
    
    // Subscribe để lắng nghe thay đổi auth state
    const unsubscribe = authService.onAuthChange((user) => {
      setIsAuthenticated(user !== null);
    });
    
    return unsubscribe;
  }, []);
  
  // Đang loading auth state
  if (isAuthenticated === null) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          animation: 'spin 1s linear infinite',
          borderRadius: '50%',
          height: '8rem',
          width: '8rem',
          borderBottom: '2px solid #4f46e5'
        }}>
          <style>{`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }
  
  // Chưa authenticated, redirect về login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Đã authenticated, hiển thị children
  return <>{children}</>;
};

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  
  useEffect(() => {
    // Kiểm tra admin status
    setIsAdmin(authService.isAdmin());
    
    // Subscribe để lắng nghe thay đổi auth state
    const unsubscribe = authService.onAuthChange((user) => {
      setIsAdmin(user ? authService.isAdmin() : false);
    });
    
    return unsubscribe;
  }, []);
  
  // Đang loading auth state
  if (isAdmin === null) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          animation: 'spin 1s linear infinite',
          borderRadius: '50%',
          height: '8rem',
          width: '8rem',
          borderBottom: '2px solid #4f46e5'
        }}>
          <style>{`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }
  
  // Không phải admin, redirect về dashboard
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // Là admin, hiển thị children
  return <>{children}</>;
};

export { ProtectedRoute, AdminRoute }; 